import React from "react";
import Layout from "../../../components/layout";
import KubeNavbar from "../../../components/navbar-kube";

const Page = () => (
  <Layout title="Kubernetes Monitoring" hasSubNav={true}>
    <KubeNavbar selection="overview"/>
    <section className="section hero is-medium kube-hero">
      <div className="hero-body">
        <div className="container">
          <div className="title has-text-centered">
            Unforseen insights into your <span style={{ color: "#326CE5" }}>Kubernetes</span> cluster
          </div>
          <div className="subtitle has-text-centered">The most detailed Kubernetes Monitoring solution</div>

          <div className="columns">
            <div className="column is-three-fifths is-offset-one-fifth " style={{marginTop: "2rem"}}>
              <div className='embed-container '>
                <iframe src="https://www.youtube.com/embed/D65QYU4H7mI" title="Dripstat Kubernetes Demo" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="section kube-features">
      <div className="container">
        <div className="feature">
          <div className="feature-head">Get the complete picture of your cluster</div>
          <div className="feature-desc">See both the state and metrics of every individual object in your cluster. No need to use tools like kubectl to see state separately from metrics.</div>
        </div>

        <div className="feature">
          <div className="feature-head">Answer complex questions with exploratory analytics</div>
          <div className="feature-desc">
            What is the resources usage per namespace? How much memory is spent in Deployments vs Daemonsets for a particular namespace? How much CPU do my helm workloads take? Our interactive slice n
            dice interface allows you to answer complex questions about your cluster instantly.
          </div>
        </div>

        <div className="feature">
          <div className="feature-head">Ensure Smooth deployments</div>
          <div className="feature-desc">
            Watch in realtime how the state and metrics of individual pods and containers changes as you make deployments. In case of failure, get the detailed root cause instantly.
          </div>
        </div>

        <div className="feature">
          <div className="feature-head">Reduce Kubernetes cluster costs</div>
          <div className="feature-desc">
            The larger your cluster, the more the chances you have overprovisioned resources. With the exploratory analytics offered by Dripstat you can pinpoint the overprovisioned workloads and
            reduce cluster costs.
          </div>
        </div>
      </div>
    </section>
  </Layout>
);

export default Page;
